import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const CONFIRMATION_MS = 2000

const STATE_IDLE = 'idle'
const STATE_COPIED = 'copied'
const STATE_FAILED = 'failed'

export default function CopyButton({ text, label }) {
  const { t } = useTranslation()
  const [state, setState] = useState(STATE_IDLE)
  const timer = useRef(null)

  useEffect(() => () => clearTimeout(timer.current), [])

  const copy = async () => {
    clearTimeout(timer.current)
    try {
      await navigator.clipboard.writeText(text)
      setState(STATE_COPIED)
    } catch (e) {
      // Clipboard access is denied outside a secure context, and the operator
      // can still select the block by hand — say so rather than failing mute.
      setState(STATE_FAILED)
    }
    timer.current = setTimeout(() => setState(STATE_IDLE), CONFIRMATION_MS)
  }

  const caption = {
    [STATE_IDLE]: label || t('natura_operations.shared.copy'),
    [STATE_COPIED]: t('natura_operations.shared.copied'),
    [STATE_FAILED]: t('natura_operations.shared.copy_failed'),
  }[state]

  return (
    <button
      type="button"
      onClick={copy}
      className={`px-2 py-1 text-xs rounded border ${
        state === STATE_FAILED ? 'border-red-300 bg-red-50 text-red-700' : 'border-gray-300 bg-white hover:bg-gray-50 text-gray-700'
      }`}
    >
      {caption}
    </button>
  )
}

CopyButton.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string,
}

CopyButton.defaultProps = {
  label: null,
}
